<div *ngIf="loading" class="spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="admin-container">
  <p-toast position="bottom-right"></p-toast>
  <p-confirmDialog></p-confirmDialog>
  <div class="files">
    <p-table
      #dt
      [value]="files | async"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      styleClass="p-datatable-gridlines"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10, 25, 50]"
      [globalFilterFields]="['name']"
    >
      <ng-template pTemplate="caption">
        <div class="header">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="searchFile($event.target)"
              placeholder="Search keyword"
            />
          </span>
          <button pButton class="ml-auto" (click)="createFile = true">
            <i class="pi pi-plus"></i>Ajouter des fichiers
          </button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Nom<p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="src">
            Url<p-sortIcon field="src"></p-sortIcon>
          </th>
          <th>Supprimer</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
        <tr>
          <td>{{ file.name }}</td>
          <td>
            <a [href]="baseUrl + file.src" download>{{ file.src }}</a>
          </td>
          <td>
            <button pButton (click)="deleteFileConfirm(file)">
              <i class="pi pi-trash"></i>Supprimer
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    header="Ajouter des fichiers"
    [(visible)]="createFile"
    [style]="{ width: '30vw' }"
  >
    <div class="modal">
      <form class="form">
        <p-fileUpload
          mode="basic"
          chooseLabel="Choose"
          name="demo[]"
          maxFileSize="1000000"
          (onSelect)="fileChanged($event)"
        ></p-fileUpload>
        <div class="submit">
          <button (click)="createFile = false">Annuler</button>
          <button (click)="saveFiles($event)">Sauver</button>
        </div>
      </form>
    </div>
  </p-dialog>
</div>
